import { reprintTicket } from './orderBoardApi.js';
import {
  loadPrintQueue,
  savePrintQueue,
  updatePrintQueueItem,
  type PrintQueueItem,
} from './printQueue.js';

export async function drainPrintQueue(): Promise<{ synced: number; failed: number }> {
  const pending = loadPrintQueue().filter((q) => q.status === 'pending' || q.status === 'failed');
  let synced = 0;
  let failed = 0;

  for (const item of [...pending].reverse()) {
    try {
      await reprintTicket(item.orderId);
      updatePrintQueueItem(item.id, {
        status: 'printed',
        updatedAt: new Date().toISOString(),
      });
      synced++;
    } catch {
      updatePrintQueueItem(item.id, {
        status: 'failed',
        retryCount: (item.retryCount ?? 0) + 1,
        updatedAt: new Date().toISOString(),
      });
      failed++;
    }
  }

  // Keep recent printed for visibility, drop older printed beyond cap via savePrintQueue.
  const next = loadPrintQueue();
  savePrintQueue(next);
  return { synced, failed };
}

export function enqueueFailedPrint(item: Omit<PrintQueueItem, 'status' | 'updatedAt'>): void {
  const entry: PrintQueueItem = {
    ...item,
    status: 'failed',
    updatedAt: new Date().toISOString(),
  };
  const rest = loadPrintQueue().filter((q) => q.id !== entry.id && q.orderId !== entry.orderId);
  savePrintQueue([entry, ...rest]);
}
